import React from 'react';
import './EmptyState.css';

/**
 * EmptyState Component
 * 
 * Displays a friendly empty state when there's no data to show.
 * Provides clear messaging and optional call-to-action.
 * 
 * @param {string} icon - Emoji or icon to display (default: "📋")
 * @param {string} title - Main heading text
 * @param {string} message - Descriptive message explaining the empty state
 * @param {ReactNode} action - Optional CTA button/link
 * @param {string} className - Additional CSS classes
 */
const EmptyState = ({ 
  icon = "📋", 
  title, 
  message, 
  action,
  className = ""
}) => {
  return (
    <div className={`empty-state ${className}`}>
      {icon && <div className="empty-state-icon" aria-hidden="true">{icon}</div>}
      {title && <h3 className="empty-state-title">{title}</h3>}
      {message && <p className="empty-state-message">{message}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
};

export default EmptyState;
